import { useEffect, useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";

interface MonthYearPickerProps {
  monthColumn: string;
  yearColumn: string;
  initialMonth: number | null;
  initialYear: number;
  currentMonth: number | null;
  currentYear: number;
  isEndDate: boolean;
  disabled: boolean;
  onChange: (value: number | null, column: string) => void;
}

function MonthYearPicker({
  monthColumn,
  yearColumn,
  initialMonth,
  initialYear,
  currentMonth,
  currentYear,
  isEndDate,
  disabled,
  onChange,
}: MonthYearPickerProps) {
  const [isModified, setIsModified] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  useEffect(() => {
    setSelectedMonth(currentMonth);
    setSelectedYear(currentYear);
    setIsModified(initialMonth !== currentMonth || initialYear !== currentYear);
  }, [initialMonth, currentMonth, initialYear, currentYear]);

  return (
    <>
      <OverlayTrigger
        trigger={"click"}
        key={""}
        placement="bottom"
        rootClose={true}
        overlay={
          <Popover id={`popover-position-bottom`}>
            <Popover.Header as="h3">
              {`Edit ${monthColumn} and ${yearColumn}`}
            </Popover.Header>
            <Popover.Body>
              <InputGroup
                className="mb-3 flex-nowrap"
                style={{ minWidth: "150px" }}
              >
                <Form.Select
                  size="sm"
                  value={selectedMonth === null ? "End" : selectedMonth}
                  onChange={(e) => {
                    setSelectedMonth(
                      e.target.value === "End"
                        ? null
                        : parseInt(e.target.value),
                    );
                    currentMonth =
                      e.target.value === "End"
                        ? null
                        : parseInt(e.target.value);
                    setIsModified(
                      initialMonth !== currentMonth ||
                        initialYear !== currentYear,
                    );
                    onChange(
                      e.target.value === "End"
                        ? null
                        : parseInt(e.target.value),
                      monthColumn,
                    );
                  }}
                >
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                  <option>10</option>
                  <option>11</option>
                  <option>12</option>
                  {isEndDate && <option>End</option>}
                </Form.Select>
                <Form.Control
                  type="number"
                  value={selectedYear}
                  onChange={(e) => {
                    setSelectedYear(parseInt(e.target.value));
                    setIsModified(
                      initialMonth !== currentMonth ||
                        initialYear !== currentYear,
                    );
                    onChange(parseInt(e.target.value), yearColumn);
                  }}
                />
              </InputGroup>
            </Popover.Body>
          </Popover>
        }
      >
        <Button
          variant={isModified ? "warning" : "primary"}
          style={{ width: "100%" }}
          size="sm"
          disabled={disabled}
        >
          {selectedMonth === null ? "End" : selectedMonth}-{selectedYear}
        </Button>
      </OverlayTrigger>
    </>
  );
}

export default MonthYearPicker;
